import { showSessionExpired } from '@/app/sessionExpiration';
import { createApiClient } from '@/shared/api/client';
import { getAccessToken } from '@/shared/lib/authSession';

export const visionLabApi = createApiClient({
  basePath: '/api',
  getAccessToken,
  onUnauthorized: showSessionExpired,
});

export const publicVisionLabApi = createApiClient({ basePath: '/api' });
